export default __webpack_public_path__ + "static/media/338.e575589b.jpg";